import { Map } from "immutable"

import {
    ATTACHMENT_LIST_REQUEST as LIST_REQUEST,
    ATTACHMENT_LIST_RESPONSE as LIST_RESPONSE,
    ATTACHMENT_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    ATTACHMENT_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    ATTACHMENT_ITEM_SAVE_RESPONSE as ITEM_SAVE_RESPONSE,
    ATTACHMENT_ITEM_DELETE_RESPONSE as ITEM_DELETE_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

const defaultSearchCriteria = Map({
    topic: ""
})

const defaultReducer = buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE,
        ITEM_SAVE_RESPONSE,
        ITEM_DELETE_RESPONSE
    },
    defaultSearchCriteria
)

export default (state = {}, action) => {
    const defaultReduction = defaultReducer(state, action)
    const { type, topic_id, data } = action

    switch (type) {
        case ITEM_SAVE_RESPONSE:
            const key = `topic=${topic_id}&userid=${data.updated_by.id}`

            return {
                ...defaultReduction,
                [key]: [
                    ...(defaultReduction[key] || []),
                    action.data.attachment_id
                ]
            }
        default:
            return defaultReduction
    }
}
